import * as React from 'react';
import UserExplorerItem from '../UserExplorerItem/UserExplorerItem';
import UserExplorerHeadTable from './UserExplorerHeadTable';

import ExplorerCurrentCategory from '../../interfaces/ExplorerCurrentCategory';
import Event from '../../interfaces/Event';

import './style.scss';

interface Props {
  events: Event[];
  filteredCategory: ExplorerCurrentCategory;
}

function UserExplorerFilter (props: Props) {

  return (
    <div>
      <UserExplorerHeadTable />
      {props.events.map((item, key) => {
        if (props.filteredCategory[item.eventCategory] || props.filteredCategory.All) {
          return (
            <UserExplorerItem
              key={key}
              timestamp={item.timestamp}
              event={item.eventLabel}
              category={item.eventCategory} />
          );
        } 
      })}
    </div>
  );
  
}

export default React.memo(UserExplorerFilter);
